// extracted by mini-css-extract-plugin
module.exports = {"container":"ItemList_container__1bjn-","itemList":"ItemList_itemList__3HiL7"};